import { render, staticRenderFns } from "./ItemEmptyListLayout.vue?vue&type=template&id=12e1e694&scoped=true&"
import script from "./ItemEmptyListLayout.vue?vue&type=script&lang=js&"
export * from "./ItemEmptyListLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e1e694",
  null
  
)

export default component.exports